module.exports = "/_next/static/images/AllYourEventsCentralized-b88a8cd1e469d4ccdc876e0121bdee8f.webp";